/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_TitleInputs */

const en_mk_faq_title = /** @type {(inputs: Mk_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ones we hear most`)
};

const id_mk_faq_title = /** @type {(inputs: Mk_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang paling sering ditanyakan`)
};

/**
* | output |
* | --- |
* | "The ones we hear most" |
*
* @param {Mk_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_title = /** @type {((inputs?: Mk_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_title(inputs)
	return en_mk_faq_title(inputs)
});